import { ButtonColor } from 'global/types/enums';
import { Button } from 'shared/components/button';

export const ErrorContent = ({
  title,
  desc,
  actionText,
  onAction
}: {
  title: string;
  desc?: string;
  actionText?: string;
  onAction?: () => void;
}) => (
  <div className="flex flex-col items-center text-center w-full">
    <div className="mb-4">
      <h2 className="font-heading font-medium mb-4 last:mb-0 text-lg text-red-600">{title}</h2>
      {desc && <p>{desc}</p>}
    </div>

    {actionText && onAction && (
      <div className="grid grid-cols-1 w-full">
        <Button label={actionText} color={ButtonColor.Secondary} onClick={onAction} />
      </div>
    )}
  </div>
);
